import type { FC, ReactChild } from 'react';
import React from 'react';

import type { SpoilerManager } from './../../ricos-viewer-next/ContentViewer/rericos/utils/SpoilerManager.js';

type SpoilerContextProps = {
  spoilerManager: SpoilerManager;
  children: ReactChild;
};

type ContextType = {
  spoilerManager: SpoilerManager;
};

export const SpoilerContext = React.createContext<ContextType>(null as unknown as ContextType);

export const SpoilerContextProvider: FC<SpoilerContextProps> = ({ spoilerManager, children }) => {
  return <SpoilerContext.Provider value={{ spoilerManager }}>{children}</SpoilerContext.Provider>;
};
